import { combineReducers } from 'redux'
import eid from "./eid";
import authentication from "./authentication";

const rootReducer = combineReducers({
    eid,
    authentication
});

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js